import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/config';

// Async thunk for submitting contact form
export const submitContactForm = createAsyncThunk(
  'contact/submitForm',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/api/v1/contact_form/query', formData)
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Something went wrong');
    }
  }
);

export const submitMailingListForm = createAsyncThunk(
  'contact/submitMailingListForm',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/api/v1/contact_form/mailing-list', {
        name: formData?.name,
        email: formData?.email,
        contactNumber: formData?.contactNumber,
        promotionalConsent: Boolean(formData?.promotionalConsent),
        sourcePage: formData?.sourcePage || 'website',
      });
      return {
        ...response.data,
        message: response.data?.message || 'Thanks! We will keep you informed.',
      };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Something went wrong');
    }
  }
);

const contactSlice = createSlice({
  name: 'contact',
  initialState: {
    loading: false,
    success: false,
    error: null,
    message: '',
  },
  reducers: {
    clearContactState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitContactForm.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(submitContactForm.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message || 'Form submitted successfully';
        // GA4 contact form submission event
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'contact_form_submit', {
            form_type: 'contact',
          });
        }
      })
      .addCase(submitContactForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(submitMailingListForm.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(submitMailingListForm.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message || 'Form submitted successfully';
        // GA4 mailing list signup event
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'signup', {
            form_type: 'mailing_list',
          });
        }
      })
      .addCase(submitMailingListForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { clearContactState } = contactSlice.actions;
export default contactSlice.reducer;